import { render, staticRenderFns } from "./stakeholderList.vue?vue&type=template&id=04d76edb&scoped=true&"
import script from "./stakeholderList.vue?vue&type=script&lang=js&"
export * from "./stakeholderList.vue?vue&type=script&lang=js&"
import style0 from "./stakeholderList.vue?vue&type=style&index=0&id=04d76edb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d76edb",
  null
  
)

export default component.exports